import React from "react"
import { Modal } from "react-bootstrap"
// import { WDTypes } from "./common"
import wdTypeInfoImage from "../../static/img/wdtypeinfobox.png"


export default class InfoWDType extends React.Component {

	constructor(props) {
		super(props);

		this.buildContentWDType = this.buildContentWDType.bind(this);
		this.close = this.close.bind(this);
	}

	buildContentWDType() {
		const { wdType } = this.props
		switch (wdType) {
			case 1:
				return <div className="form-default form-s">
					<img src={wdTypeInfoImage} className="img-fluid" />
				
					<p className="font-strong">Giới thiệu</p>
					
					<p> Tài xế sẽ đón và đưa bạn di chuyển đến các địa điểm trong cùng thành phố. </p>
					<p>- Bạn không cần nhập Điểm đến, hãy trao đổi lộ trình mong muốn với Tài xế. </p>

					<p className="font-strong">Giá thuê</p>
					<p>- Giá thuê của chuyến đi được tính theo thời gian bạn lựa chọn trên ứng dụng, đã bao gồm tiền tài xế, xăng xe, phí qua đêm.</p>
				
				</div>
			case 2: 
				return <div className="form-default form-s">
					<img src={wdTypeInfoImage} className="img-fluid" />
				
					<p className="font-strong">Giới thiệu</p>
					
					<p> - Liên tỉnh 1 chiều là dịch vụ dành cho những khách hàng muốn di chuyển từ TPHCM/Hà Nội/Thành phố khác đến các tỉnh lân cận. </p>
					<p>- Bạn vui lòng nhập Điểm đón và Điểm đến. </p>

					<p className="font-strong">Giá thuê</p>
					<p>- Giá thuê của chuyến đi được tính theo hành trình (thời gian và lộ trình) bạn lựa chọn trên ứng dụng, đã bao gồm tiền tài xế, xăng xe, phí qua đêm (chưa bao gồm phí cầu đường).</p>
					<p>- Giá hiển thị trên ứng dụng là giá 1 chiều (chiều đi). Tài xế sẽ đi cùng bạn trong suốt hành trình và đưa bạn đến địa điểm bạn đã chọn trên ứng dụng.</p>
				
				</div>
			case 3: 
				return <div className="form-default form-s">
					<img src={wdTypeInfoImage} className="img-fluid" />
					<p className="font-strong">Giới thiệu</p>
					<p>- Liên tỉnh 2 chiều là dịch vụ dành cho khách hàng muốn di chuyển từ TPHCM/Hà Nội/Thành phố khác đến các tỉnh lân cận. </p>
					<p>- Bạn vui lòng nhập Điểm đón và Điểm đến. </p>
					<p className="font-strong">Giá thuê</p>
					<p>- Giá thuê của chuyến đi được tính theo hành trình (thời gian và lộ trình) bạn lựa chọn trên ứng dụng, đã bao gồm tiền tài xế, xăng xe, phí qua đêm (chưa bao gồm phí cầu đường).</p>
					<p>- Giá hiển thị trên ứng dụng là giá 2 chiều (chiều đi và chiều về). Tài xế sẽ đi cùng bạn trong suốt hành trình và đưa bạn về lại địa điểm ban đầu.</p>
				</div>
		}
	}

	close() {
		this.props.onHide()
	}

	render() {
		const { wdType } = this.props;
		let title = wdType === 1 ? "Thuê xe di chuyển Nội thành" : wdType === 2 ? "Thuê xe di chuyển Liên tỉnh - 1 chiều" : "Thuê xe di chuyển Liên tỉnh - 2 chiều"
		return (
			<Modal
			show={this.props.show}
			onHide={this.close}
			dialogClassName={`modal-dialog modal-info-type`}
			aria-labelledby="ModalHeader"	
		>
			<Modal.Header id='ModalHeader' closeButton={true} closeLabel={""}>
					<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{this.buildContentWDType()}
			</Modal.Body>
		</Modal>
		)
	}

}



// WEBPACK FOOTER //
// ./src/components/car/infopopup.js